import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SmallFaq } from "../../../shared/small-faq/small-faq";
import { Footer } from "../../../shared/footer/footer";
import { AlwaysThere } from "../../../shared/always-there/always-there";
import { InterestYou } from "../../../shared/interest-you/interest-you";
import { CatalogService } from '../../../modules/catalog/catalog.service';
import { Navbar } from "../../../shared/navbar/navbar";
import { BasketService } from '../../basket/basket.service';
import { RouterLink } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Title,Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-product-list',
  imports: [SmallFaq, Footer,Navbar, AlwaysThere, InterestYou, CommonModule,RouterLink],
  templateUrl: './product-list.html',
  styleUrl: './product-list.css',
})
export class ProductList implements OnInit {
  products: Product[] = [];
  dataurl = "";
  operateur = "";

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private catalogService: CatalogService,
    private basketService: BasketService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private cdr: ChangeDetectorRef,private metaService: Meta,private titleService: Title
  ) {
    var metaTitle = "Forfaits réseau Orange 4G/5G sans engagement | YouPrice";
    this.titleService.setTitle(metaTitle);
    this.metaService.updateTag({ name: 'description', content: "Profitez de forfaits 4G/5G sur le réseau Orange sans engagement à petit prix : XXGo, XXGo, XXGo ou XXGo. Découvrez aussi l'eSIM sur le réseau Orange." });
  }
createBasket(product: any) {
    product.operators = product?.operateur;
    this.basketService.createBasket(product);
    const gtmTag = {
    event: 'select_item',
    ecommerce: {
      currency: "EUR",
      items: [
          {
             item_id: product.id,
             item_name: "Forfaits "+ product.libelle + " "+ product.operators,
             item_category: product.libelle,
             item_category2: product.operators,
             discount: 0,
             price: product.maxTarif
          }
      ]
   }
  };
  if (isPlatformBrowser(this.platformId)) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(gtmTag);
  }
  }
   goToOffer(operator: string, urlName: string,p:any) {
    if (operator && urlName) {
      if (isPlatformBrowser(this.platformId)) {
        (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'select_item',
        ecommerce: {
          currency: "EUR",
          items: [
              {
                 item_id: p.id,
                 item_name: "Forfaits "+ p.libelle + " "+ p.operators,
                 item_category: p.libelle,
                 item_category2: p.operators,
                 discount: 0,
                 price: p.maxTarif
              }
          ]
       }});
    }
      this.route.navigate(['/forfaits-mobile-'+operator, urlName]);
    }
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      var gtmTag = {
        event: 'virtual_page_view',
        ecommerce: null,
        page_location: 'https://www.youprice.fr/',
        page_path: '/',
        content_group: 'HP',
        user_id: ''
      };
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(gtmTag);
    }
    let url: any = "forfaits-100Go-reseau-orange";
    url = this.activatedRoute.snapshot.paramMap.get("slug");
    if (url == undefined || url == '' || url == 'null') {
      this.dataurl = url;
      this.route.navigate(['/']);
      return;
    }
    this.catalogService.GetProductForV2ByUrlFilter(url).subscribe((data: ProductResponse) => {
      setTimeout(() => {
        let operateur = "";
        let productIdes = (data.products || []).map(p => p.id).join(',');
        let processedProducts = (data.products || []).map(product => {
          let newUrlName = product.urlName;
          this.titleService.setTitle(data.metaTitle);
          if (newUrlName) {
            const lastDashIndex = newUrlName.lastIndexOf('-');
            if (lastDashIndex !== -1) {
              operateur = product.operateur;
              newUrlName = newUrlName.substring(0, lastDashIndex);
            }
          }

          




          return {
            ...product, 
            urlName: newUrlName
          };
        });
        processedProducts.sort((a, b) => {
          const volA = a.maxVolume ?? 0;
          const volB = b.maxVolume ?? 0;
          return volA - volB;
        });
        if (isPlatformBrowser(this.platformId)) {
            var gtmTag = {
              zone: 'listing',
              categoryId: operateur,
              products: productIdes,
            };
            (window as any).dataLayer = (window as any).dataLayer || [];
            (window as any).dataLayer.push(gtmTag);
          }
        this.products = processedProducts;
        this.operateur =operateur;
        this.cdr.detectChanges();
        
      });
    });
  }
}

export interface ProductResponse {
  products: Product[];
  metaTitle: string;
}

export interface Product {
  operators: string;
  operateur: string;
  isMomenProduct: boolean;
  inclus5G: boolean;
  prix?: string;
  gigas?: string;
  reseau?: string;
  urlName: string;
  id?: string;
  classification?: string;
  promo?: boolean;
  simPrice?: number;
  maxVolume: number;
  maxTarif: number;
  fonctionalites?: string;
  fonctionalitesList?: any;
  forfaitRoamingEuropVolume: number;
  dateEndValidation?: Date;
}